

<script lang="ts">
  import { getTabs } from "./navigation"
  import type { OverviewFrameContext } from "./navigation"
  import type { PageContext } from "./navigation"

  import HomeTab from "./tabs/Home"
  import SessionsTab from "./tabs/sessions"
  import StatisticsTab from "./tabs/statistics"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: OverviewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => ({
    permissions: viewFrameContext.permissions,
    organization: viewFrameContext.organization,
  }))
  const canOpenActiveTab = $derived(getTabs(viewFrameContext).some((tab) => tab.id === activeTab))
</script>

{#if activeTab === "home"}
  <HomeTab {viewFrameContext} {pageContext} />
{:else if activeTab === "sessions" && canOpenActiveTab}
  <SessionsTab {viewFrameContext} {pageContext} />
{:else if activeTab === "statistics" && canOpenActiveTab}
  <StatisticsTab {viewFrameContext} {pageContext} />
{/if}
